import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function UrgencySection() {
  return <section className="py-32 px-4 bg-radial-gold relative overflow-hidden" data-id="element-146">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-147">
        <motion.h2 initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-display text-4xl md:text-6xl text-gold mb-6 italic" data-id="element-148">
          Limited Spots This Week
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="font-body text-xl md:text-2xl text-cream mb-12 font-light" data-id="element-149">
          Book now and secure your spot with the best.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-150">
          <CTAButton pulse className="text-lg md:text-xl px-12 py-6 w-full sm:w-auto" data-id="element-151">
            Book My Spot Now
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}